<template>
    <v-dialog v-model="listSettingsModal" max-width="1000" persistent>
        <v-card>
            <v-card-title class="headline">{{ "Choose columns to show" | t }}</v-card-title>
            <v-card-subtitle class="subtitle-1 mb-0 pb-0">{{
                "Select which fields will be selected" | t
            }}</v-card-subtitle>
            <v-card-text>
                <v-row no-gutters>
                    <v-col v-for="row in listSettingsColumns" :key="row.text" md="4" sm="12">
                        <v-checkbox
                            v-if="row.value !== 'actions'"
                            hide-details
                            class="mt-0 mb-0"
                            @click.stop="toggleListSettingsColumn(row)"
                            :label="row.text | t"
                            :input-value="row.isSelected"
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="bal-dark-gray" text @click="toggleListSettingsModal">
                    {{ "Close" | t }}
                </v-btn>

                <v-btn color="bal-green" text @click="handleReturnClick">
                    {{ "Save" | t }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
export default {
    name: "export-sale-invoice-list-settings-modal",
    computed: {
        ...mapState("ExportSaleInvoiceStore", ["listSettingsModal", "listSettingsColumns", "exportInvoiceTableHeaders"])
    },
    mounted() {
        document.addEventListener("keydown", this.handleEscClick);
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleEscClick);
    },
    methods: {
        ...mapMutations("ExportSaleInvoiceStore", [
            "toggleListSettingsModal",
            "toggleListSettingsColumn",
            "setExportInvoiceTableHeaders",
            "setRequestError",
            "setErrorMessage"
        ]),
        ...mapActions("UserStore", ["saveUserExportInvoiceSearchColumnSettings"]),
        async handleReturnClick() {
            let counter = 0;
            await this.listSettingsColumns.forEach(x => {
                if (x.isSelected === true) counter++;
            });
            if (counter > 1) {
                await this.setExportInvoiceTableHeaders();
                await this.toggleListSettingsModal();
                await this.saveUserExportInvoiceSearchColumnSettings(this.exportInvoiceTableHeaders);
            } else {
                this.setRequestError(true);
                this.setErrorMessage("You must choose more than zero columns.");
            }
        },
        handleEscClick(e) {
            if (e.keyCode === 27 && this.listSettingsModal) {
                e.preventDefault();
                this.toggleListSettingsModal();
            }
        }
    }
};
</script>

<style scoped></style>
